export default __webpack_public_path__ + "static/media/ellipse.0027aca2.svg";